import React from "react";
import styled from "styled-components";
import SiteButton from "./SiteButton";
import { revealProps } from "./Reveal";
import { CTA } from "./site.data";
import { C, MQ } from "./WebsiteTheme.style";

const CtaBandWrapper = styled.section`
	position: relative;
	overflow: hidden;
	padding: 72px 0;
	background: ${C.band};

	/* Soft waves, drawn in CSS so the band has no image to load */
	&::before,
	&::after {
		content: "";
		position: absolute;
		border-radius: 50%;
		pointer-events: none;
	}

	&::before {
		left: -12%;
		bottom: -70%;
		width: 60%;
		height: 140%;
		background: radial-gradient(closest-side, rgba(31, 99, 224, 0.45), rgba(31, 99, 224, 0));
	}

	&::after {
		right: -10%;
		top: -80%;
		width: 50%;
		height: 160%;
		background: radial-gradient(closest-side, rgba(122, 78, 230, 0.35), rgba(122, 78, 230, 0));
	}

	${MQ.TABLET} {
		padding: 64px 0;
	}

	${MQ.PHONE} {
		padding: 56px 0;
	}

	.sc_inner {
		position: relative;
		z-index: 1;
		display: grid;
		grid-template-columns: minmax(0, 1fr) auto;
		align-items: center;
		gap: 40px;

		${MQ.STACK} {
			grid-template-columns: 1fr;
			gap: 28px;
		}
	}

	.sc_copy {
		display: flex;
		flex-direction: column;
		gap: 12px;
		max-width: 780px;
	}
`;

/**
 * Closing call to action at the end of the Home and About pages: same band, same two buttons,
 * same order. Only the title and line change per page.
 */
const SiteCtaBand = ({ title, text }) => (
	<CtaBandWrapper className="sm_on_dark">
		<div className="sm_container sc_inner" {...revealProps("up")}>
			<div className="sc_copy">
				<h2 className="sm_title">{title}</h2>
				<p className="sm_lead">{text}</p>
			</div>
			<div className="sm_btn_row">
				<SiteButton to={CTA.pilot.to}>{CTA.pilot.label}</SiteButton>
				<SiteButton to={CTA.demo.to} variant="light">
					{CTA.demo.label}
				</SiteButton>
			</div>
		</div>
	</CtaBandWrapper>
);

export default SiteCtaBand;
